import { Injectable, Injector } from '@angular/core';
import { ActivationRegimeDto } from '@authority-labs/api-interfaces';
import { CrudService } from '@check-list/app/shared/services/crud/crud.service';

@Injectable({
  providedIn: 'root'
})
export class ActivationRegimeService extends CrudService<ActivationRegimeDto> {
  constructor(injector: Injector) {
    super(injector, 'activation-regimes', ActivationRegimeDto);
  }
}
